import React, { useEffect, useState } from "react";
import { db } from "../base";
import Layout from "../layout";
import "./list-produits.scss";
import ListCatalogue from "../components/listes-catalogues/ListCategoriesCatalogues";

const ListPdfClients = () => {
  const [pdfCategory, setPdfCategory] = useState([]);
  const collectionCategorys = "pdf-categorys";
  const collection = "catalogues-clients";

  useEffect(() => {
    db.collection(collectionCategorys)
      .orderBy("order", "asc")
      .onSnapshot((snapshot) => {
        setPdfCategory(
          snapshot.docs.map((doc) => ({
            key: doc.id,
            id: doc.id,
            category: doc.data().category,
          }))
        );
      });
  }, []);

  return (
    <Layout title={"Liste Catalogues"}>
      <div id="liste_produits">
        <div className="links">
          {pdfCategory.map((catalogue) => (
            <ListCatalogue
              key={catalogue.id}
              catalogue={catalogue}
              collection={collection}
            />
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default ListPdfClients;
